import React, { useContext } from 'react';
import styled from 'styled-components';
import { Button, Card, Link, Title } from '@bb/elements-web';
import PaymentConfirmationContent from '../../PaymentConfirmationPage';
import { StyledPageContent } from '../StyledComponents';
import AnsweringServiceContext, {
  AnsweringServiceSubscribeStep,
} from '../AnsweringServiceContext';

/**
 * The page that shows during the Answering Service subscription flow
 * confirming the monetary total with the user and allowing them to make
 * any billing changes they want.
 */
const PaymentConfirmation: React.FC = () => {
  const { createSubscription, setCurrentStep, subscribeBtnLoading } =
    useContext(AnsweringServiceContext);

  return (
    <StyledPageContent>
      <StyledCard dataCy="payment-confirmation-card">
        <Title level={3} dataCy="activate-plan-title">
          Payment & Confirmation
        </Title>
        <StyledActivationContainer>
          <PaymentConfirmationContent
            billingInfo={{ placeholder: 'object' }}
            handleAddAddressClick={() => {
              console.log('TODO: Open up address modal here.');
            }}
            handleAddPaymentInfoClick={() => {
              console.log('TODO: Open up credit card modal here.');
            }}
            serviceType="liveConcierge"
          />
        </StyledActivationContainer>
        <ConfirmBackContainer>
          <StyledLink
            onClick={
              subscribeBtnLoading
                ? undefined
                : () =>
                    setCurrentStep(AnsweringServiceSubscribeStep.ManageListings)
            }
            $disabled={subscribeBtnLoading}
          >
            Back
          </StyledLink>
          <Button
            minWidth="auto"
            type="primary"
            // TODO: The following onClick is the correct functionality. The second onClick skipping directly to the SubscriptionSuccess is only for testing the UI flow.
            // onClick={createSubscription}
            onClick={() =>
              setCurrentStep(AnsweringServiceSubscribeStep.SubscriptionSuccess)
            }
            loading={subscribeBtnLoading}
            dataCy="confirm-pay-btn"
          >
            Confirm
          </Button>
        </ConfirmBackContainer>
      </StyledCard>
    </StyledPageContent>
  );
};

const ConfirmBackContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledActivationContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  margin-top: 24px;
`;

const StyledCard = styled(Card)`
  padding: 10px;
  width: 550px;
`;

const StyledLink = styled(Link)<{ $disabled?: boolean }>`
  color: black;
  margin-right: 25px;
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
`;

export default PaymentConfirmation;
